import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/legal/terms-of-use')({
  component: TermsOfUse,
})

function TermsOfUse() {
  return (
    <main
      style={{
        maxWidth: '780px',
        margin: '0 auto',
        padding: '120px 24px 80px',
      }}
    >
      <p
        style={{
          fontSize: '13px',
          color: '#3B82F6',
          marginBottom: '8px',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          fontWeight: '600',
        }}
      >
        Legal
      </p>
      <h1
        style={{
          fontSize: 'clamp(28px, 4vw, 48px)',
          fontWeight: '800',
          color: '#111827',
          margin: '0 0 8px',
          letterSpacing: '-1px',
        }}
      >
        Terms of Use
      </h1>
      <p
        style={{ fontSize: '14px', color: '#9CA3AF', marginBottom: '56px' }}
      >
        Last updated: 21 October 2025
      </p>

      <Section title="Acceptance">
        By accessing or using GetCode you agree to these Terms of Use. If you do
        not agree, please do not use the service.
      </Section>

      <Section title="Eligibility">
        You must be at least 18 years old to create an account or use GetCode. By
        using the service you confirm that you meet this requirement.
      </Section>

      <Section title="What GetCode Does">
        GetCode provides temporary virtual phone numbers that allow you to receive
        one-time SMS verification codes for account creation or sign-in on
        supported online services. Numbers are session-based and allocated only
        for the specified platform and time window.
      </Section>

      <Section title="Prohibited Activities">
        You may not use GetCode for:
        <ul>
          <li>Any unlawful purpose, including fraud or money laundering.</li>
          <li>Child exploitation or any content harmful to minors.</li>
          <li>
            Creating multiple accounts to abuse platform limits or promotions.
          </li>
          <li>Sending spam or unsolicited commercial messages.</li>
          <li>Scraping data from GetCode or any third-party service.</li>
          <li>Attempting unauthorized access to any system or network.</li>
          <li>
            Evading security controls via VPNs, proxies, or rotating/residential
            IPs to manipulate traffic.
          </li>
        </ul>
        Violations may result in immediate account suspension without refund.
      </Section>

      <Section title="Credits & Payments">
        All credit purchases are non-refundable. If a verification attempt fails
        due to a service-side issue, you may receive a credit adjustment rather
        than a cash refund. Your statutory consumer rights remain unaffected.
      </Section>

      <Section title="Number Allocation">
        Each number is temporary and tied to a single platform and session.
        Excessive or abusive use of a number may result in it being blocked. No
        refund will be issued in such cases.
      </Section>

      <Section title="Service Availability">
        GetCode is provided "as is" without warranties of any kind. We do not
        guarantee uninterrupted availability or delivery of any particular SMS
        message. Our liability for any transaction is limited to the amount you
        paid for that specific transaction.
      </Section>

      <Section title="Intellectual Property">
        All content, branding, and software comprising GetCode are the exclusive
        property of GetCode and its licensors. You may not reproduce, distribute,
        or create derivative works without prior written consent.
      </Section>

      <Section title="Termination">
        We reserve the right to suspend or terminate your account at any time
        for breach of these Terms. You may close your account by contacting
        support.
      </Section>

      <Section title="Dispute Resolution">
        Any disputes will first be addressed through good-faith negotiation. If
        unresolved, disputes are subject to the jurisdiction of the courts
        applicable to your region of residence. Consumer protection rights under
        local law always apply.
      </Section>

      <Section title="Changes to These Terms">
        We may update these Terms from time to time. We will notify you of
        material changes with reasonable advance notice. Continued use of GetCode
        after the effective date constitutes acceptance.
      </Section>

      <Section title="Contact">
        Questions about these Terms?{' '}
        <a href="mailto:support@getcode.app" style={{ color: '#3B82F6' }}>
          support@getcode.app
        </a>
      </Section>
    </main>
  )
}

function Section({
  title,
  children,
}: {
  title: string
  children: React.ReactNode
}) {
  return (
    <section style={{ marginBottom: '40px' }}>
      <h2
        style={{
          fontSize: '20px',
          fontWeight: '700',
          color: '#111827',
          margin: '0 0 12px',
          letterSpacing: '-0.3px',
        }}
      >
        {title}
      </h2>
      <div
        style={{
          fontSize: '15px',
          color: '#6B7280',
          lineHeight: '1.8',
        }}
      >
        {children}
      </div>
    </section>
  )
}
